import { FormErrors } from "@mantine/form";

/**
 * Collects the plain-text messages from a Mantine form's validation errors.
 *
 * @param errors Errors keyed by form path; each value is a message or a list of messages.
 * @returns Every string message, in field order. Non-string (React node) messages are skipped.
 */
export function getFormErrorMessages(errors: FormErrors): string[] {
  return Object.values(errors).reduce<string[]>((messages, error) => {
    const fieldMessages: unknown[] = Array.isArray(error) ? error : [error];
    fieldMessages.forEach((message) => {
      if (typeof message === "string") messages.push(message);
    });
    return messages;
  }, []);
}

/**
 * Builds the Sign & Lock validation toast message for an amendment form.
 *
 * @param errors Validation errors from the amendment form.
 * @returns A message listing each failing field, or a generic prompt when no message is plain text.
 */
export function getSignAndLockValidationMessage(errors: FormErrors): string {
  const messages = getFormErrorMessages(errors);
  if (messages.length === 0) return SIGN_AND_LOCK_GENERIC_VALIDATION_MESSAGE;
  return `Please fix the following before signing: ${messages.join(", ")}`;
}

const SIGN_AND_LOCK_GENERIC_VALIDATION_MESSAGE =
  "Please fix the highlighted fields before signing.";
